import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Mail, Phone, Linkedin, Calendar } from 'lucide-react';

const PreviewTeam = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const teamMembers = [
    {
      name: "Michael Permack",
      photo: "/team-michael.jpg",
      email: "m.permack@spiregrp.com",
      phone: "403.462.5560",
      linkedin: "http://ca.linkedin.com/in/michaelpermack",
      calendly: "https://calendly.com/michaelpermack/"
    },
    {
      name: "Jeff Sklar",
      photo: "/team-jeff.jpg",
      email: "j.sklar@spiregrp.com",
      phone: "403.483.5561",
      linkedin: "http://ca.linkedin.com/pub/jeff-sklar/4a/533/750"
    },
    {
      name: "Jason Shantz",
      photo: "/team-jason.jpg",
      email: "j.shantz@spiregrp.com",
      phone: "403.874.1129",
      linkedin: "https://www.linkedin.com/in/jason-shantz-5561a131"
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1758448721149-aa0ce8e1b2c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400"
            alt="Premium Healthcare Lobby"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-spire-purple/90 to-purple-900/75"></div>
        </div>

        <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center z-10">
          <div className="animate-fade-in-up">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Our Team
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Experienced professionals dedicated to your real estate success in North America
            </p>
          </div>
        </div>
      </section>

      {/* Team Members */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-12">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 text-center group">
                <div className="overflow-hidden">
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-6">{member.name}</h3>
                  <div className="space-y-3">
                    <a href={`mailto:${member.email}`} className="flex items-center justify-center gap-2 text-gray-600 hover:text-spire-purple transition-colors">
                      <Mail size={16} />
                      <span className="text-sm">{member.email}</span>
                    </a>
                    <a href={`tel:${member.phone}`} className="flex items-center justify-center gap-2 text-gray-600 hover:text-spire-purple transition-colors">
                      <Phone size={16} />
                      <span className="text-sm">{member.phone}</span>
                    </a>
                    {member.linkedin && (
                      <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 text-gray-600 hover:text-spire-purple transition-colors">
                        <Linkedin size={16} />
                        <span className="text-sm">LinkedIn</span>
                      </a>
                    )}
                    {member.calendly && (
                      <a href={member.calendly} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 px-6 py-3 bg-spire-purple text-white rounded-xl font-semibold hover:bg-purple-700 transition-all">
                        <Calendar size={16} />
                        Book a Call
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Ready to Work With Us?</h2>
          <p className="text-xl text-gray-600 mb-10">
            Our team is ready to help you navigate your healthcare real estate needs
          </p>
          <Link
            to="/preview/contact"
            className="inline-flex items-center px-8 py-4 bg-spire-purple text-white rounded-xl font-semibold text-lg hover:bg-purple-700 transition-all duration-300 hover:scale-105 shadow-xl"
          >
            Get in Touch
            <ArrowRight className="ml-2" size={20} />
          </Link>
        </div>
      </section>

      {/* Preview Badge */}
      <div className="fixed bottom-4 right-4 bg-yellow-500 text-black px-6 py-3 rounded-full font-bold shadow-2xl z-50">
        🎨 PREVIEW MODE
      </div>
    </div>
  );
};

export default PreviewTeam;
